import { getStaticTypoPcMo, getTypo, getTypoPcMo, getTypoRaw } from './index.ts';

/* js든 ts든 이것을 import 해서 사용 */
export const typo = getTypo;
export const staticTypo = getTypoRaw;
export const typoPcMo = getTypoPcMo;
export const staticTypoPcMo = getStaticTypoPcMo;
